import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import axiosInstance from "../../../../Services/axiosCommon";
import {
  BackButton,
  CreateButton,
  EditButton,
} from "../../../../Components/Utils/Buttons";
import NuDate from "../../../../Components/Utils/NuDate";
import {
  NormalHeading,
  SmallHeading,
} from "../../../../Components/Utils/Heading";
import FilesView from "../../../../Components/Utils/FilesView";
import CommonComments from "../../../../Components/Utils/commonComments";
import { MainFormInput } from "../../../../Components/Utils/MainForm";
import { useFormik } from "formik";
import ToggleUp from "../../../../Components/Icons/ToggleUp";
import ToggleDown from "../../../../Components/Icons/ToggleDown";
import { Progress } from "antd";
import { handleKeyDown } from "../../../../Components/Utils/OtherFunction";
import ClientLayout from "./ClientLayout";
import { GetAccess } from "../../../../Components/Utils/roles";

function ViewClient(onClose) {
  const location = useLocation();
  const cData = location.state?.data;
  const { clientViewId } = useParams();

  const [data, setData] = useState(cData ? cData : null);

  function getView() {
    axiosInstance
      .get(`/clients/${clientViewId}`)
      .then((res) => {
        setData(res.data?.data);
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  useEffect(() => {
    // if (!cData) {
    getView();
    // }
  }, []);

  const pageIndex = location.state?.pageIndex;
  const searchQuery = location.state?.searchQuery;
  const [percentOpen, setPercentOpen] = useState(false);
  const [createNew, setCreateNew] = useState({
    name: "",
  });
  const [expandedIndex, setExpandedIndex] = useState(null);

  const handleToggle = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  const [filePathList, setFilePathList] = useState([]);
  useEffect(() => {
    if (
      data?.clientLogo !== null &&
      data?.clientLogo !== "None" &&
      data?.clientLogo !== "[]"
    ) {
      setFilePathList(data?.clientLogo?.length > 0 ? data?.clientLogo : []);
    }
  }, [data]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,

    onSubmit: (values) => console.log("Form Submitted", values),
  });

  return (
    <ClientLayout
      EditAccess={GetAccess("clients_edit")}
      // BackAccess={GetAccess("client_management_module")}
    >
      <div className="w-full mx-auto h-[calc(100vh-160px)] mt-0.5    md:flex gap-x-2 text-[#111537]">
      <div className=" md:w-[70%]  bg-white rounded-md drop-shadow-lg py-1 overflow-hidden ">
        <div className="sm:w-[98%]  bg-white px-2 mx-2 border border-gray py-2 rounded-lg sm:flex justify-between  gap-4 items-center  z-10">
          <div className="flex gap-4">
            <div className="w-16 2xl:w-20 bg-slate-100  h-16 2xl:h-20 flex justify-center items-center rounded-md border-2  border-baseColor-secondary bg-basColor-quartary border-solid overflow-hidden">
              {/* <img className='w-full h-auto' src={data.image?.file} alt='#' /> */}
              {data?.image?.file
                ? data?.image?.file && (
                    <img
                      src={data.image?.file}
                      alt={`${data?.image?.file}`}
                      className="object-cover"
                    />
                  )
                : data?.companyName[0]}
            </div>
            <div className="grid  items-center ">
              <div className=" mb-1 text-[#111537] font-semibold w-[100%]">
                <p className="flex text-lg">{data?.companyName}</p>
                <p className="flex text-[#606279] text-xs">{data?.refNumber}</p>
              </div>
              {/* <div className="flex gap-4 justify-between">
                 <p className="text-xs text-[#111537]">Date : 05-03-2025</p>
               </div> */}
            </div>
          </div>
<div className=" flex items-center mt-2 sm:mt-0  overflow-hidden rounded-full text-[10px] 2xl:text-xs  ">
                            <div className="  p-2 h-6  bg-white  rounded-s-full text-xs flex items-center border border-textColor-main">
                              Status{" "}
                            </div>
                            <div className="  p-2 h-6  bg-textColor-main text-white text-xs  rounded-e-full flex items-center">
                              {data?.status || "-"}
                            </div>
                          </div>
        </div>

        <div className="h-[calc(100vh-250px)] overflow-y-auto p-2 pb-8 ">
        <div className="px-1">
            <p className="text-xs font-medium text-[#111537] p-1">Client Details :</p>
          </div>
          <div className=" w-full flex flex-wrap  px-2 border border-gary   rounded-lg ">
            {/* {data?.image.file && ( */}

            {/* )} */}
            <div className=" w-full sm:grid grid-cols-2 gap-x-8 mt-3">
              <div className="w-full flex px-2">
                <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Phone
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                  : {data?.phoneWithCC}
                </p>
              </div>

              <div className="w-full flex px-2">
                <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Email
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                  : {data?.email}
                </p>
              </div>
              <div className="w-full flex px-2">
                <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Website
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                  : {data?.website}
                </p>
              </div>
              <div className="w-full flex px-2">
                <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Industry
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                  : {data?.industry}
                </p>
              </div>

              <div className="w-full flex px-2">
                <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  CR Number
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                  : {data?.crNum}
                </p>
              </div>

              <div className="w-full flex px-2">
                <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  VAT Number
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                  : {data?.vatNum}
                </p>
              </div>
              <div className="w-full flex px-2">
                <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Sales Person
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                  : {data?.salesPersonName}
                </p>
              </div>

              <div className="w-full flex px-2">
                <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Ratings
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                  : {data?.ratings}
                </p>
              </div>

              {/* <div className="w-full flex px-2">
                   <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                     Inspection Date
                   </p>
                   <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                     :{" "}
                     {data?.inspectionDate ? (
                       <NuDate
                         value={data?.inspectionDate}
                         format="DD-MMM-YYYY"
                       />
                     ) : (
                       "N/A"
                     )}
                   </p>
                 </div> */}
            </div>
          </div>
          <div className="px-1 mt-2">
            <p className="text-xs font-medium text-[#111537] p-1">Address :</p>
          </div>
          <div className=" w-full flex flex-wrap  px-2 border border-gary   rounded-lg ">
            <div className=" w-full sm:grid grid-cols-2 gap-x-8 mt-3">
              <div className="w-full flex px-2">
                <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Address Line 1
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                  : {data?.address1}
                </p>
              </div>
              <div className="w-full flex px-2">
                <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Address Line 2
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                  : {data?.address2}
                </p>
              </div>
              <div className="w-full flex px-2">
                <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  City
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                  : {data?.city}
                </p>
              </div>
              <div className="w-full flex px-2">
                <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Street Name
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                  : {data?.streetName}
                </p>
              </div>

              <div className="w-full flex px-2">
                <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  District
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                  : {data?.district}
                </p>
              </div>

              <div className="w-full flex px-2">
                <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  State / Province
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                  : {data?.state}
                </p>
              </div>
              <div className="w-full flex px-2">
                <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Postal / Zip Code
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                  : {data?.postalCode}
                </p>
              </div>
              <div className="w-full flex px-2">
                <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Country
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                  : {data?.country}
                </p>
              </div>

            </div>
          </div>
          <div className="sm:flex gap-4 my-4">
            <div className="sm:w-[50%]">
              <p className="text-xs font-medium text-[#111537] p-1">
                Billing Address
              </p>

              <div className="border border-gray h-28 overflow-y-scroll rounded-lg">
                <div className="text-xs p-2 leading-snug">
                  <p>
                    {[data?.billingAddress1, data?.billingAddress2]
                      .filter(Boolean)
                      .join(", ")}
                  </p>
                  <p>
                    {[
                      data?.billing_city,
                      data?.billing_state,
                      data?.billing_postal_code,
                      data?.billing_country,
                    ]
                      .filter(Boolean)
                      .join(", ")}
                  </p>
                </div>
              </div>
            </div>
            <div className="sm:w-[50%]">
              <p className="text-xs font-medium text-[#111537] p-1">
                Delivery Address
              </p>

              <div className="border border-gray h-28 overflow-y-scroll rounded-lg">
                <div className="text-xs p-2 leading-snug">
                  <p>
                    {[data?.shippingAddress1, data?.shippingAddress2]
                      .filter(Boolean)
                      .join(", ")}
                  </p>
                  <p>
                    {[
                      data?.shipping_city,
                      data?.shipping_state,
                      data?.shipping_postal_code,
                      data?.shipping_country,
                    ]
                      .filter(Boolean)
                      .join(", ")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="md:w-[30%] bg-white rounded-lg drop-shadow-lg py-1 mt-5 md:mt-0">
        <div className="h-[98%] overflow-y-scroll p-2 ">
          <div className="w-full grid  border border-gary   rounded-lg">
            <div className="bg-baseColor-primary  p-2 rounded-t-lg">
              <p className="text-xs text-white font-medium">Primary Contact</p>
            </div>
            {/* <p className="text-xs text-[#111537] font-medium">Customer Detail</p> */}

            <div className="w-full flex px-2 justify-between">
              <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                Name
              </p>
              <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                : {data?.pcName}
              </p>
            </div>
            <div className="w-full flex px-2 justify-between">
              <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                {" "}
                Designation
              </p>
              <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                {" "}
                : {data?.pcDesignation}
              </p>
            </div>
            <div className="w-full flex px-2 justify-between">
              <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                {" "}
                Phone
              </p>
              <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                {" "}
                : {data?.pcMobile}
              </p>
            </div>
            <div className="w-full flex px-2 justify-between">
              <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                {" "}
                Email
              </p>
              <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                {" "}
                : {data?.pcEmail}
              </p>
            </div>
          </div>

          {(data?.scName ||
            data?.scDesignation ||
            data?.scMobile ||
            data?.scEmail) && (
            <div className="w-full grid border border-gray-200 rounded-lg mt-3">
              <div className="bg-baseColor-primary p-2 rounded-t-lg">
                <p className="text-xs text-white font-medium">
                  Secondary Contact
                </p>
              </div>

              <div className="w-full flex px-2 justify-between">
                <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                  Name
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                  : {data?.scName}
                </p>
              </div>

              <div className="w-full flex px-2 justify-between">
                <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                  Designation
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                  : {data?.scDesignation}
                </p>
              </div>

              <div className="w-full flex px-2 justify-between">
                <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                  Phone
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                  : {data?.scMobile}
                </p>
              </div>

              <div className="w-full flex px-2 justify-between">
                <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                  Email
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                  : {data?.scEmail}
                </p>
              </div>
            </div>
          )}

          {/* <div className="w-full grid  border border-gary mt-4  rounded-lg ">
               <p className="text-xs text-white font-medium bg-baseColor-primary  p-2 rounded-t-lg">
                 Forms{" "}
               </p>
               <div className=" w-full flex flex-wrap overflow-y-scroll h-16">
                 <div
                   onClick={[]}
                   className="cursor-pointer m-1 w-auto h-[25px] flex items-center  justify-between  rounded p-[2px] border "
                 >
                   <svg
                     width="20"
                     height="20"
                     fill="#3369ff"
                     xmlns="http://www.w3.org/2000/svg"
                     viewBox="0 0 512 512"
                   >
                     <path d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z" />
                   </svg>
                   <p className="w-auto text-[10px]">
                     {data?.ref || "Survey form"}
                   </p>
                 </div>
               </div>
             </div> */}

          {/* <div className="w-full h-auto flex  border border-gary mt-4 overflow-hidden rounded-lg">
               <CommonComments
                 visible={true}
                 title="Comments"
                 mainId={data?.prId}
                 addurl={"/pr-comments/new-comment"}
                 geturl={`/pr-comments/by-PR/${data?.prId}`}
               />
             </div> */}
        </div>
      </div>
      </div>
    </ClientLayout>
  );
}

export default ViewClient;

function test({ data = {} }) {
  return (
    <>

    </>
  );
}
